__turbopack_context__.v({
  "description": "SettingsField-module__z-EvuG__description",
  "field": "SettingsField-module__z-EvuG__field",
  "label": "SettingsField-module__z-EvuG__label",
});
